import { createFileRoute, redirect } from "@tanstack/react-router";

// Redirect URL cũ /i-ching → /kinh-dich (giữ backlink/SEO sau khi đổi slug).
export const Route = createFileRoute("/i-ching")({
  beforeLoad: () => {
    throw redirect({ to: "/kinh-dich", replace: true });
  },
  component: () => null,
});
